import { ISettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';
import { ISettlementAndFeeCategoryDefinitionData } from 'types/order/fees/ISettlementAndFeeCategoryDefinition';
import { availablePropertiesBySelection } from './useAvailablePropertiesBySelection';

export const removeHiddenFeeProperties = (
  lineItemForm: ISettlementItemForm,
  options: ISettlementAndFeeCategoryDefinitionData[]
): ISettlementItemForm => {
  const filteredLineItem = { ...lineItemForm };

  filteredLineItem.statementFees = lineItemForm.statementFees.map((fee) => {
    const properties = availablePropertiesBySelection(
      options,
      fee.statementSettlementAndFeeCategoryDefinitionId,
      fee
    );

    // Ensure we have valid property objects
    if (!properties || typeof properties !== 'object') {
      return fee; // Return original fee if properties cannot be determined
    }

    const numericProps = fee.numericFeePropertyValues || {};
    const stringProps = fee.stringFeePropertyValues || {};
    const propertiesMap = properties as Record<string, any>;

    // Filter properties to only include visible ones
    const filteredNumericProperties = Object.fromEntries(
      Object.entries(numericProps).filter(([key]) => propertiesMap[key])
    );
    
    const filteredStringProperties = Object.fromEntries(
      Object.entries(stringProps).filter(([key]) => propertiesMap[key])
    );

    return {
      ...fee,
      numericFeePropertyValues: filteredNumericProperties,
      stringFeePropertyValues: filteredStringProperties,
    };
  });

  return filteredLineItem;
}; 